import { render, staticRenderFns } from "./designBackground.vue?vue&type=template&id=2435e1ec&scoped=true"
import script from "./designBackground.vue?vue&type=script&lang=js"
export * from "./designBackground.vue?vue&type=script&lang=js"
import style0 from "./designBackground.vue?vue&type=style&index=0&id=2435e1ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2435e1ec",
  null
  
)

export default component.exports